module.exports = __webpack_public_path__ + "static/Incident_2-0648d9f5c13f56fe88b96a68480c2a97.png";